import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { checkVersionAndReloadIfStale } from './lib/versionCheck';
import './styles/globals.css';

// Bei jedem App-Start prüfen ob Frontend-Build und Server-Version
// übereinstimmen. Sonst: SW unregister, Caches leeren, reload.
// Läuft nebenher und blockiert das Rendering nicht.
void checkVersionAndReloadIfStale();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 5 Sek. ist kompromiss: nicht zu aggressives Refetching, aber
      // beim Wechsel zwischen Detail- und Terminprogramm-Seite sind
      // Mutations garantiert eingeflossen, ohne dass man hart reloaden muss.
      staleTime: 5_000,
      retry: 1,
      // Beim Zurückkehren ins Fenster (z.B. nach Edit in anderem Tab) frisch ziehen.
      refetchOnWindowFocus: true,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root-Element fehlt');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
